/* tslint:disable */
/* eslint-disable */
/**
 * SR AAT specification
 * Description
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ProductEnablement } from './ProductEnablement';
import {
    ProductEnablementFromJSON,
    ProductEnablementFromJSONTyped,
    ProductEnablementToJSON,
} from './ProductEnablement';

/**
 * 
 * @export
 * @interface EnableProduct
 */
export interface EnableProduct {
    /**
     * 
     * @type {ProductEnablement}
     * @memberof EnableProduct
     */
    productEnablement: ProductEnablement;
}

/**
 * Check if a given object implements the EnableProduct interface.
 */
export function instanceOfEnableProduct(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "productEnablement" in value;

    return isInstance;
}

export function EnableProductFromJSON(json: any): EnableProduct {
    return EnableProductFromJSONTyped(json, false);
}

export function EnableProductFromJSONTyped(json: any, ignoreDiscriminator: boolean): EnableProduct {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'productEnablement': ProductEnablementFromJSON(json['productEnablement']),
    };
}

export function EnableProductToJSON(value?: EnableProduct | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'productEnablement': ProductEnablementToJSON(value.productEnablement),
    };
}

